import { getFromInUrl, isDriverOrFood } from '@/config/core';
import userStore from '@/stores/user/index';
import { ENTRY_POINT } from '@/types/entryPoints';
import { formatFromInUrl } from '../instantLoaded/toolsWithoutDeps';

const newSupoortChatbotDirverEntrypoints = [
  ENTRY_POINT.DriverAppSPXSamedayOrderOngoingPage,
  ENTRY_POINT.DriverAppSPXSamedayOrderDetailPage,
  ENTRY_POINT.DriverAppSPXSamedayOrderHistoryPage,
  ENTRY_POINT.DriverAPPReportSPXiIssuePage,
  ENTRY_POINT.DriverAPPSPXOrderPage,
  ENTRY_POINT.DriverAPPSPXiOrderHistoryPage,
  ENTRY_POINT.DriverAPPSPXiOrderDetailsPage,
];

export const isDriverAndFoodUIOptimisation = () => {
  if (!isDriverOrFood()) {
    return false;
  }

  const entrypoint = formatFromInUrl(getFromInUrl());
  if (newSupoortChatbotDirverEntrypoints.includes(entrypoint as ENTRY_POINT)) {
    return true;
  }

  return (userStore.newABTestingConfigs as any)?.ABtestforShopeeFoodDriverAppSPXentrypoints === 'test';
};
